import React from 'react'
import './_styles.scss'
import Utils from '../../../../../../../../../../../utils/Utils'

const hexToRgba = (hex, alpha) => {
 const cleanHex = hex.replace('#', '');
 const r = parseInt(cleanHex.substring(0, 2), 16);
 const g = parseInt(cleanHex.substring(2, 4), 16);
 const b = parseInt(cleanHex.substring(4, 6), 16);
 return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

function PlayerCard ({ name, subtitle, statLabel, statValue, photoUrl, color, isLast }) {
  return (
    <div className={'country-details-header__player-card' + (isLast ? ' country-details-header__player-card--last' : '')}>
      <div className='country-details-header__player-card-left-bg' style={{ background: `linear-gradient(to left, ${hexToRgba(color, 0.8)}, ${hexToRgba(color, 0.5)})` }}>
        <div className='country-details-header__player-card-photo-wrapper'>
          <img className='country-details-header__player-card-photo' src={photoUrl || ''} alt='' />
        </div>
      </div>
      <div className='country-details-header__player-card-body-bg' style={{ background: `linear-gradient(to left, ${hexToRgba(color, 0.8)}, ${hexToRgba(color, 0.5)})` }}>
        <p className='country-details-header__player-card-name'>{Utils.cutPlayerString(name, 16)}</p>
        <p className='country-details-header__player-card-subtitle'>{Utils.cutPlayerString(subtitle, 20)}</p>
        <div className='country-details-header__player-card-stat'>
          <p className='country-details-header__player-card-stat-label'>{Utils.cutPlayerString(statLabel, 12)}</p>
          <p className='country-details-header__player-card-stat-value'>{statValue}</p>
        </div>
      </div>
    </div>
  )
}

export default PlayerCard



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsHeader/Components/CountryDetailsCenter/Components/PlayerCard/index.jsx